'use client'
import { SbBlokData, storyblokEditable, StoryblokServerComponent } from '@storyblok/react/rsc'
import { FC } from 'react'

import { PhnxBrucebanner } from './Brucebanner'
import { BrucebannerProps } from './Brucebanner'

interface BrucebannerBlokProps {
  blok: {
    title: BrucebannerProps['title']
    subtitle: BrucebannerProps['subtitle']
    description: BrucebannerProps['description']
    asset: any
    frameSrc: BrucebannerProps['frameSrc']
    heroForm: any
    frameHeight: any
    customForm?: any
    content: any
    washOpacity?: number
    variant?: BrucebannerProps['variant']
  } & SbBlokData
}

const Brucebanner: FC<BrucebannerBlokProps> = ({ blok }) => {
  return (
    <div {...storyblokEditable(blok)}>
      <PhnxBrucebanner
        title={blok.subtitle ? blok.subtitle : ''}
        subtitle={blok.title}
        description={blok.description}
        variant={blok.variant}
        asset={
          blok.asset
            ? {
                src: blok.asset.filename,
                alt: blok.asset.alt,
                focus: blok.asset.focus,
                washOpacity: blok.washOpacity ? blok.washOpacity : 0,
              }
            : undefined
        }
        frameSrc={blok.frameSrc ? blok.frameSrc : undefined}
        content={
          blok.content &&
          blok.content.map((nestedBlok: SbBlokData) => (
            <StoryblokServerComponent blok={nestedBlok} key={nestedBlok._uid} />
          ))
        }
        heroForm={
          blok.heroForm &&
          blok.heroForm.map((nestedBlok: SbBlokData) => (
            <StoryblokServerComponent blok={nestedBlok} key={nestedBlok._uid} />
          ))
        }
        customForm={
          blok.customForm &&
          blok.customForm.map((nestedBlok: SbBlokData) => (
            <StoryblokServerComponent blok={nestedBlok} key={nestedBlok._uid} />
          ))
        }
        minHeight={blok.frameHeight}
        mobileMinHeight={blok.frameHeight}
      />
    </div>
  )
}

export default Brucebanner
